import {
  ChromeExtensionMemoryTracker,
  LinuxMemoryTracker,
  MacMemoryTracker,
  WindowsMemoryTracker,
} from 'constants/memoryTracker';
import type { MemoryTracker } from 'types/memoryTracker';
import { getOS, OS } from './os-detection';

interface MemoryTrackerOptions {
  /**
   * Whether prerelease trackers (currently only Memory for Linux) may be recommended.
   * Linux is a prerelease/beta tracker (see `prereleaseApps` in `constants/known-apps`),
   * so it must only be offered to beta-enabled accounts. Prefer the beta-aware selectors
   * in `redux/selectors/memoryTracker` over passing this manually.
   */
  allowPrereleaseTrackers?: boolean;
}

export function getRecommendedMemoryTracker({
  allowPrereleaseTrackers = false,
}: MemoryTrackerOptions = {}): MemoryTracker | null {
  const os = getOS();

  if (os === OS.Mac) {
    return MacMemoryTracker;
  } else if (os === OS.Windows) {
    return WindowsMemoryTracker;
  } else if (os === OS.Linux) {
    return allowPrereleaseTrackers ? LinuxMemoryTracker : null;
  } else if (isChromeExtensionPreferred()) {
    return ChromeExtensionMemoryTracker;
  } else {
    return null;
  }
}

function isChromeExtensionPreferred(): boolean {
  const ua = window.navigator.userAgent ?? '';
  return ua.includes('CrOS');
}

export function getTicCompatibleMemoryTracker({
  allowPrereleaseTrackers = false,
}: MemoryTrackerOptions = {}): MemoryTracker | null {
  const os = getOS();
  if (os === OS.Mac) {
    return MacMemoryTracker;
  }
  if (os === OS.Windows) {
    return WindowsMemoryTracker;
  }
  if (os === OS.Linux) {
    return allowPrereleaseTrackers ? LinuxMemoryTracker : null;
  }
  return null;
}
